/* const API_NEARCODE = 'http://v2.nearcodeconsulting.com/' */
const API_NEARCODE = 'https://api.nearcodeconsulting.com/'
export default API_NEARCODE